module.exports = __webpack_public_path__ + "img/about.f688f77a.png";